import { ILmsUserLeadResponse } from '.';
import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { usePermissionCheckForApiCallback } from '../../../../authGuard';

export const useLmsUserLeadsQuery = (): IQueryResponse<Array<ILmsUserLeadResponse>> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('lms_user_leads');
	const { permissionForApi } = usePermissionCheckForApiCallback({ componentName: 'AllUsers' });

	const fetchLmsUserLeadsData = async (): Promise<Array<ILmsUserLeadResponse>> => {
		const response = await APIService.getData<Array<ILmsUserLeadResponse>>(`${APICONFIG.LMS_LEADS_LISTING}`, {
			limit: '0',
		});
		if (response) {
			setRxdb('lms_user_leads', response);
		}
		return response;
	};

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['LMS User Leads'],
		queryFn: fetchLmsUserLeadsData,
		enabled: permissionForApi ? isDbChecked && shouldFetch : false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
		isFetching,
	};
};
